import React, { useState, useEffect } from "react";
import axios from "axios";
import Resizer from "react-image-file-resizer";
import { useMutation, gql } from "@apollo/client";

import { server } from "../../utills/utils";

import HomeImg from "../../assets/shopdefault.png";
import EditModal from "../Modals/ProductModal";
import Spinner from "../Modals/SpinnerModal";

import styled from "styled-components";

const UPLOAD_FILE = gql`
  mutation uploadToAws($file: Upload!) {
    uploadToAws(file: $file) {
      url
    }
  }
`;

const Container = styled.div`
  width: 90%;
  height: auto;
  background: #f5f5f5;
  padding: 3.5% 5% 10% 5%;
  border-radius: 5px;
`;
const Title = styled.h2`
  font-size: 1.2em;
  margin: 0;
  padding: 0;
  font-weight: 500;
`;
const ShopDetails = styled.div`
  width: 100%;
  height: auto;
  padding: 0;
`;
const ShopName = styled.h2`
  font-size: 1.3em;
  font-weight: 500;
  margin: 0;
  padding: 3px 0 10px 0;
  float: left;
`;
const ShopName2 = styled.h2`
  font-size: 1.3em;
  font-weight: 500;
  margin: 0;
  padding: 3px 0 5px 0;
`;
const ShopImage = styled.div`
  width: 100%;
  height: 350px;
  margin: 0 0 20px 0;
`;
const ShopImage2 = styled.div`
  width: 100%;
  height: 350px;
  margin: 10px 0 10px 0;
`;

const Image = styled.img`
  height: 100%;
  width: 100%;
  border-radius: 5px;
`;

const Location = styled.div``;
const ShopLocation = styled.h3`
  font-size: 1em;
  font-weight: 500;
  margin: 0;
  padding: 10px 0 10px 0;
`;
const EditButton = styled.button`
  float: right;
  padding: 8px 30px;
  font-weight: bold;
  border-radius: 5px;
  cursor: pointer;
`;
const Input = styled.input`
  width: 92.9%;
  padding: 15px 3.3%;
  font-size: 15px;
  border: 1px solid #eee;
  border-radius: 5px;
  outline: none;
  color: gray;
`;
const ShopBio = styled.textarea`
  width: 92.9%;
  padding: 15px 3.3%;
  font-size: 15px;
  border: 1px solid #eee;
  border-radius: 5px;
  outline: none;
  color: gray; ;
`;

const EditBody = styled.div`
  width: 94%;
  padding: 20px 0;
  margin-left: 3%;
  height: auto;
`;

const SaveButton = styled.button`
  width: 100%;
  padding: 13px 0;
  margin: 10px 0;
  cursor: pointer;
  font-weight: bold;
  background: #276fb7;
  border: none;
  border-radius: 5px;
  color: white;
`;

const Uploading = styled.div`
  width: 100%;
  height: 350px;
  margin: 10px 0 10px 0;
  background: rgb(180, 177, 177);
  border-radius: 5px;
  @keyframes mymove {
    from {
      background-color: #e6e1e1;
    }
    to {
      background-color: #c7caca;
    }
  }
`;
const SubTitle = styled.h3`
  padding: 0;
  margin: 15px 0 5px 0;
  font-weight: 600;
  font-size: 1em;
`;

const ShopProfile = styled.div`
  width: 100%;
  height: 230px;
  text-align: center;
`;
const ProfileImage = styled.img`
  width: 200px;
  height: 200px;
  text-align: center;
  border-radius: 100%;
`;
function Settings() {
  const [shop, setShop] = useState({});
  const [complete, setComplete] = useState(false);
  const [editModal, setModal] = useState(false);
  const [coverUrl, setUrl] = useState("");
  const [uploading, setUploading] = useState(false);
  const [spinner, setSpinner] = useState(false);
  const [profileUpload, setUploadingProfile] = useState(false);
  const [profileUrl, setProfileUrl] = useState("");
  const [name, setName] = useState("");
  const [bio, setBio] = useState("");
  const [deliveryCharge, setCharge] = useState(25);
  const [localAddress, setLocalAddress] = useState("");

  const nameChangeHandler = (e) => {
    setName(e.target.value);
  };
  const bioChangeHandler = (e) => {
    setBio(e.target.value);
  };
  const chargeChangeHandler = (e) => {
    setCharge(e.target.value);
  };
  const addressChangeHandler = (e) => {
    setLocalAddress(e.target.value);
  };
  const updateHandler = async () => {
    if (!uploading) {
      if (
        name !== shop.name ||
        (coverUrl && coverUrl !== shop.coverImage) ||
        (profileUrl && profileUrl !== shop.profileImage) ||
        (bio && bio !== shop.bio) ||
        deliveryCharge !== shop.deliveryCharge ||
        localAddress !== shop.localAddress
      ) {
        try {
          // const UpdateShopInput = {
          //   name,
          //   coverImage: coverUrl,
          //   shopId: localStorage.shopId,
          // };
          setSpinner(true);
          await axios
            .post(server, {
              query: `
                           mutation{
                              updateShop(name:"${name}", bio:"${bio}", coverImage:"${coverUrl}",profileImage:"${profileUrl}", shopId:"${localStorage.shopId}", deliveryCharge:${deliveryCharge}, localAddress:"${localAddress}"){
                                  name
                                  cityName
                                  thanaName
                                  phone
                                  bio
                                  adminProducts
                                  deliveredOrders
                                  pendingOrders
                                  coverImage
                                  deliveryCharge
                                  profileImage
                                  localAddress
                              }
                           }
                         `,
            })
            .then((res) => {
              const data = res.data.data.updateShop;
              setShop(data);
              setName(data.name);
              setBio(data.bio);
              if (data.deliveryCharge) {
                setCharge(data.deliveryCharge);
              }
              setUrl(data.coverImage);
              setComplete(true);
              setModal(false);
              setSpinner(false);
              console.log(res);
            });
        } catch (error) {
          console.log(error);
        }
      } else {
        setModal(false);
      }
    }
  };

  const resizeFile = (file) =>
    new Promise(async (resolve) => {
      await Resizer.imageFileResizer(
        file,
        1200,
        1200,
        "WEBP",
        100,
        0,
        (uri) => {
          // resolve(uri);

          const file = uri;

          uploadToAws({ variables: { file } });
        },
        "file"
      );
    });
  const resizeFileProfile = (file) =>
    new Promise(async (resolve) => {
      await Resizer.imageFileResizer(
        file,
        1200,
        1200,
        "WEBP",
        100,
        0,
        (uri) => {
          // resolve(uri);

          const file = uri;

          uploadToAwsProfile({ variables: { file } });
        },
        "file"
      );
    });
  const handleFileChange = async (e) => {
    setSpinner(true);
    setUploading(true);
    const file = e.target.files[0];
    resizeFile(file);
  };
  const handleProfileChange = async (e) => {
    setSpinner(true);
    setUploadingProfile(true);
    const file = e.target.files[0];
    resizeFileProfile(file);
  };
  const [uploadToAwsProfile] = useMutation(UPLOAD_FILE, {
    onCompleted: (data) => {
      console.log(data);
      setProfileUrl(data.uploadToAws.url);
      setUploadingProfile(false);
      setSpinner(false);
    },
  });
  const [uploadToAws] = useMutation(UPLOAD_FILE, {
    onCompleted: (data) => {
      console.log(data);
      setUrl(data.uploadToAws.url);
      setUploading(false);
      setSpinner(false);
    },
  });

  const fetchShop = async (args, req) => {
    const shop = await axios.post(server, {
      query: `
                query{
                  shop(shopId:"${localStorage.shopId}"){
                    name
                    cityName
                    thanaName
                    phone
                    bio
                    adminProducts
                    deliveredOrders
                    pendingOrders
                    coverImage
                    deliveryCharge
                    profileImage
                    localAddress
                  }
                }
              `,
    });
    const data = shop.data.data.shop;
    console.log("Data", data);
    setShop(data);
    setName(data.name);
    if (data.deliveryCharge) {
      setCharge(data.deliveryCharge);
    }
    setBio(data.bio);
    setUrl(data.coverImage);
    setComplete(true);
    setProfileUrl(data.profileImage);
    setLocalAddress(data.localAddress);
  };
  const modalHandler = () => {
    setModal(!editModal);
  };
  useEffect(() => {
    fetchShop();
  }, []);
  return (
    <Container>
      {/* <Title>Settings</Title> */}
      <Spinner show={spinner} />
      {complete ? (
        <ShopDetails>
          <EditModal show={editModal} closeModal={modalHandler}>
            <EditBody>
              <ShopName2>Edit details</ShopName2>

              <SubTitle>Shop name</SubTitle>

              <Input
                onChange={nameChangeHandler}
                name={name}
                placeholder="Shop name"
                value={name}
              />
              <SubTitle>Shop Bio</SubTitle>

              <ShopBio
                onChange={bioChangeHandler}
                name={bio}
                placeholder="Shop bio"
                value={bio}
              />
              <SubTitle>Address</SubTitle>

              <ShopBio
                onChange={addressChangeHandler}
                name={localAddress}
                placeholder="Address"
                value={localAddress}
              />
              <SubTitle>Delivery charge</SubTitle>

              <Input
                onChange={chargeChangeHandler}
                name={deliveryCharge}
                type="number"
                placeholder="Delivery charge"
                value={deliveryCharge}
              />
              <SubTitle>Shop profile</SubTitle>
              <ShopProfile>
                {profileUrl && profileUrl !== "null" ? (
                  <ProfileImage src={profileUrl} alt="cover" />
                ) : (
                  <ProfileImage src={HomeImg} alt="cover" />
                )}
                <div style={{ width: "100%", padding: "5px" }}>
                  {" "}
                  <input onChange={handleProfileChange} type="file" />
                </div>
              </ShopProfile>

              <SubTitle>Shop cover</SubTitle>
              <ShopImage2>
                {uploading ? (
                  <Uploading></Uploading>
                ) : coverUrl && coverUrl !== "null" ? (
                  <Image src={coverUrl} alt="cover" />
                ) : (
                  <Image src={HomeImg} alt="cover" />
                )}
                {/* {coverUrl ? (
                  <Image src={coverUrl} alt="cover" />
                ) : (
                  <Image src={HomeImg} alt="cover" />
                )} */}
              </ShopImage2>
              <input onChange={handleFileChange} type="file" />
              <SaveButton onClick={updateHandler}>Save changes</SaveButton>
            </EditBody>
          </EditModal>
          <div style={{ height: "50px" }}>
            <ShopName>{shop.name}</ShopName>
            <EditButton onClick={modalHandler}>Edit</EditButton>
          </div>
          <SubTitle>Shop Bio</SubTitle>
          <p style={{ padding: "0", margin: "0" }}>{shop.bio}</p>
          <SubTitle>Address</SubTitle>
          <p style={{ padding: "0", margin: "0" }}>
            {shop.localAddress ? (
              shop.localAddress
            ) : (
              <button onClick={modalHandler}>Set Address</button>
            )}
          </p>
          <SubTitle>Shop profile</SubTitle>
          <ShopProfile>
            {profileUrl && profileUrl !== "null" ? (
              <ProfileImage src={profileUrl} alt="cover" />
            ) : (
              <ProfileImage src={HomeImg} alt="cover" />
            )}
            <div style={{ width: "100%", padding: "5px" }}> </div>
          </ShopProfile>
          <SubTitle>Shop cover</SubTitle>
          <ShopImage>
            {coverUrl && coverUrl !== "null" ? (
              <Image src={coverUrl} alt="cover" />
            ) : (
              <Image src={HomeImg} alt="cover" />
            )}
          </ShopImage>
          <Location>
            <SubTitle>Delivery Charge</SubTitle>
            <p style={{ padding: "0", margin: "0" }}>
              {shop.deliveryCharge ? shop.deliveryCharge : 50}
            </p>
          </Location>
          <Location>
            <SubTitle>Phone</SubTitle>
            <p style={{ padding: "0", margin: "0" }}>{shop.phone}</p>
          </Location>
          <Location>
            <SubTitle>Location</SubTitle>
            <p style={{ padding: "0", margin: "0" }}>
              {shop.cityName} , {shop.thanaName}
            </p>
          </Location>
        </ShopDetails>
      ) : (
        <p>Loading...</p>
      )}
    </Container>
  );
}

export default Settings;
